import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/newDesign/closePop.png'


const _withScopeId = n => (_pushScopeId("data-v-4c9f0a42"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "닫기",
  style: {"height":"23px"}
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "popTitle commonBigHeaderText" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "닫기",
  style: {"height":"23px"}
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "flexAlignCenter textToggleBtns"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "textCenter fontBold fontSmall" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "popNoHeader popTitle commonBigHeaderText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_gBtnList = _resolveComponent("gBtnList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "popBackShadow",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.pPopInfo.closeFn && _ctx.pPopInfo.closeFn(...args)))
    }),
    (_openBlock(), _createBlock(_resolveDynamicComponent('layout'), {
      class: "popLayoutWrap boxShadow",
      style: _normalizeStyle(_ctx.responsiveSize)
    }, {
      default: _withCtx(() => [
        (_ctx.pPopInfo.noHeader ? false : true && _ctx.pPopInfo.title !== 'tabs')
          ? (_openBlock(), _createElementBlock("header", {
              key: 0,
              style: _normalizeStyle({ color: _ctx.pPopInfo.fontColor })
            }, [
              _createElementVNode("div", {
                class: "backBtn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pPopInfo.closeFn && _ctx.pPopInfo.closeFn(...args)))
              }, _hoisted_2),
              _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.pPopInfo.title), 1)
            ], 4))
          : (_ctx.pPopInfo.title === 'tabs')
            ? (_openBlock(), _createElementBlock("header", _hoisted_4, [
                _createElementVNode("div", {
                  class: "backBtn",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pPopInfo.closeFn && _ctx.pPopInfo.closeFn(...args)))
                }, _hoisted_6),
                (_ctx.$route.path === '/')
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mSelectBtn, (btn, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createElementVNode("div", {
                            onClick: ($event: any) => (_ctx.pSelectedToggle(index)),
                            class: _normalizeClass([{selectedToggleBtn: _ctx.pIsSelectedIndex===index}, "cursorP textToggleBtn"])
                          }, [
                            _createElementVNode("p", _hoisted_9, _toDisplayString(btn.btnText), 1)
                          ], 10, _hoisted_8)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("header", _hoisted_10, [
                _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.pPopInfo.title), 1)
              ])),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true),
        _createElementVNode("footer", {
          style: _normalizeStyle({ backgroundColor: _ctx.pPopInfo.footerColor })
        }, [
          _createVNode(_component_gBtnList, {
            pBtnList: _ctx.pPopInfo.btnList
          }, null, 8, ["pBtnList"])
        ], 4)
      ]),
      _: 3
    }, 8, ["style"]))
  ], 64))
}